import React from 'react';
import classNames from 'classnames';
import { ReactComponent as CancelButtonSvg } from '../images/ma-cancel-icon.svg';
import { ReactComponent as FileIconSvg } from '../images/ma-file-icon.svg';
import { ReactComponent as ErrorIconSvg } from '../images/error-icon.svg';
import { ExtendedFile } from '../types';
import styles from './AttachmentBanners.module.css';

export function AttachmentBanners({
  attachments,
  removeAttachmentAtIndex,
}: {
  attachments: ExtendedFile[];
  removeAttachmentAtIndex: (index: number) => void;
}) {
  return (
    <div>
      {attachments.map((attachment, index: number) => {
        const restricted = attachment.unacceptedType;
        return (
          <div
            className={classNames(styles.attachmentBanner, { [styles.restricted]: restricted })}
            key={attachment.name}
          >
            <div className={styles.fileIcon}>
              {restricted ? (
                <ErrorIconSvg width="22" height="24" viewBox="10 10 85 85" />
              ) : (
                <FileIconSvg />
              )}
            </div>
            <div className={styles.attachmentName}>{attachment.name}</div>
            {restricted && <div className={styles.restricted}>RESTRICTED</div>}
            <button onClick={() => removeAttachmentAtIndex(index)} className={styles.cancelButton}>
              <CancelButtonSvg />
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default AttachmentBanners;
